import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';

const AnimatedCounter = ({ value, duration = 2 }) => {
  const ref = useRef(null);
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, {
    damping: 50,
    stiffness: 100
  });
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [displayValue, setDisplayValue] = useState('0');

  useEffect(() => {
    if (isInView) {
      // Parse the value to handle formats like "50,000+" or "4.8/5"
      let numericValue = 0;
      let suffix = '';
      
      if (typeof value === 'string') {
        // Extract number and suffix
        const match = value.match(/([\d,\.]+)(.*)/);
        if (match) {
          numericValue = parseFloat(match[1].replace(/,/g, ''));
          suffix = match[2];
        }
      } else {
        numericValue = value;
      }

      motionValue.set(numericValue);

      const unsubscribe = springValue.on('change', (latest) => {
        const formatted = Math.floor(latest).toLocaleString();
        setDisplayValue(formatted + suffix);
      });

      return () => unsubscribe();
    }
  }, [isInView, value, motionValue, springValue]);

  return (
    <motion.span
      ref={ref}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.5 }}
    >
      {displayValue}
    </motion.span>
  );
};

export default AnimatedCounter;
